<template>
  <!-- Aggiungi un partecipante alla conversazione (PatientChatSection). Una
       frase che dice chi si può aggiungere;
       i medici aggiungibili come righe da scegliere, la stessa forma dei
       canali della chat (.chat-channel, quella scelta con l'anello teal);
       caricamento, errore e nessun medico come .empty-state. Bottoni della
       famiglia popup-button. -->
  <b-modal
    :id="modalId"
    :title="$t('ChatPartecipanti.titolo')"
    title-tag="h2"
    :header-close-label="$t('chiudi')"
    size="lg"
    centered
    :ok-title="$t('ChatPartecipanti.conferma')"
    :cancel-title="$t('annulla')"
    :ok-disabled="!scelto || salvataggio"
    ok-variant="popup-button"
    cancel-variant="popup-button"
    @show="carica"
    @ok="conferma"
  >
    <div class="text-left">
      <p class="list-row__meta mb-3">{{ $t("ChatPartecipanti.spiegazione") }}</p>

      <div v-if="caricamento" class="empty-state py-3" role="status">
        <b-spinner small></b-spinner>
        <p>{{ $t("ChatPartecipanti.caricamento") }}</p>
      </div>

      <div v-else-if="errore" class="empty-state empty-state--danger py-3" role="alert">
        <b-icon icon="exclamation-circle" class="empty-state__icon" aria-hidden="true"></b-icon>
        <p>{{ $t("ChatPartecipanti.errore_elenco") }}</p>
        <b-button variant="outline-secondary" size="sm" @click="carica">{{ $t("riprova") }}</b-button>
      </div>

      <div v-else-if="medici.length === 0" class="empty-state py-3">
        <b-icon icon="people" class="empty-state__icon" aria-hidden="true"></b-icon>
        <p>{{ $t("ChatPartecipanti.nessuno") }}</p>
      </div>

      <ul
        v-else
        class="list-stack list-stack--capped list-unstyled mb-0"
        role="list"
        :aria-label="$t('ChatPartecipanti.scegli')"
      >
        <li v-for="m in medici" :key="m.hashid">
          <button
            type="button"
            class="list-row chat-channel"
            :class="{ 'chat-channel--active': scelto === m.hashid }"
            :aria-pressed="scelto === m.hashid ? 'true' : 'false'"
            @click="scelto = m.hashid"
          >
            <span class="list-row__icon list-row__icon--teleconsulto" aria-hidden="true">
              <b-icon :icon="scelto === m.hashid ? 'check2' : 'person-badge-fill'"></b-icon>
            </span>
            <span class="list-row__body">
              <span class="list-row__title d-block text-break">{{ nome(m) }}</span>
              <span v-if="m.email" class="list-row__meta d-block text-break">{{ m.email }}</span>
            </span>
          </button>
        </li>
      </ul>
    </div>
  </b-modal>
</template>

<script>
import { chatService } from "@/_services";

// Fa entrare un altro medico nella conversazione. Si possono aggiungere solo i
// medici che hanno già una propria chat abilitata con lo stesso paziente: lo
// decide il server (chat/channels/{hashid}/participants/eligible), qui si
// mostra l'elenco che manda. Per ora non si esce.
export default {
  name: "ModalAggiungiPartecipante",
  props: {
    modalId: {
      type: String,
      default: "modal-aggiungi-partecipante",
    },
    channelHashid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      medici: [],
      scelto: null,
      caricamento: false,
      errore: false,
      salvataggio: false,
    };
  },
  methods: {
    carica() {
      this.scelto = null;
      this.errore = false;
      this.caricamento = true;
      chatService
        .getEligibleParticipants(this.channelHashid)
        .then((res) => {
          this.medici = (res.data && res.data.data) || [];
          if (this.medici.length === 1) {
            this.scelto = this.medici[0].hashid;
          }
        })
        .catch(() => {
          this.medici = [];
          this.errore = true;
        })
        .finally(() => {
          this.caricamento = false;
        });
    },
    conferma(evento) {
      evento.preventDefault();
      if (!this.scelto || this.salvataggio) return;
      this.salvataggio = true;
      chatService
        .addParticipant(this.channelHashid, this.scelto)
        .then((res) => {
          this.$bvToast.toast(this.$t("ChatPartecipanti.aggiunto"), {
            title: this.$t("ChatPartecipanti.titolo_successo"),
            variant: "success",
            solid: true,
          });
          this.$emit("aggiunto", res.data && res.data.data);
          this.$bvModal.hide(this.modalId);
        })
        .catch((err) => {
          const msg = (err && err.data && err.data.message) || this.$t("ChatPartecipanti.errore_aggiunta");
          this.$bvToast.toast(msg, {
            title: this.$t("ChatPartecipanti.titolo_errore"),
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.salvataggio = false;
        });
    },
    nome(m) {
      const n = `${m.name || ""} ${m.surname || ""}`.trim();
      return n || m.email || "";
    },
  },
};
</script>
